import { FormItem } from "@/types/base"
import moment from "moment"



export const formListLeft:FormItem[]= [{
    name: 'projectName',
    label: '项目名称',
    disabled: true,
    type: 'text',
    required: true,
    placeholder: '',
    itemType: 'input',
  },{
    name: 'productType',
    label: '产品类型',
    type: 'text',
    placeholder: '请输入产品类型',
    required: true,
    rules: [{ required: true, message: '请输入产品类型' },{
                max: 50,
                message: "最大输入50个字符",
              }],
    itemType: 'input',
  },{
    name: 'questionType',
    label: '问题领域',
    type: 'text',
    placeholder: '请选择问题领域',
    required: true,
    rules: [{ required: true, message: '请选择问题领域' }],
    options:[
      // { label: '编译烧录', value: '编译烧录' },
      // { label: '北向应用', value: '北向应用' },
      // { label: '北向框架', value: '北向框架' },
      // { label: '南向适配', value: '南向适配' },
      // { label: '硬件开发', value: '硬件开发' },
    ],
    itemType: 'select',
  },{
    name: 'planCompleteTime',
    label: '计划完成时间',
    type: 'text',
    required: true,
    rules: [{ required: true, message: '请选择计划完成时间' }],
    placeholder: '请选择计划完成时间',
    disabledDate: (current: any) => current && (current.isBefore(moment().endOf('day'), 'day') ),
    itemType: 'datePicker',
  },{
    name: 'questionUser',
    label: '提问人',
    type: 'text',
    required: true,
    placeholder:'请输入提问人姓名',
    rules: [
      { required: true, message: '请输入提问人姓名' },
      {
        max: 10,
        message: "最大输入10个字符",
    }],
    itemType: 'input',
  }] 


  export const formListRight:FormItem[]=[{
    name: 'projectProgress',
    label: '项目进度',
    required: true,
    placeholder: '请选择项目进度',
    options:[
      // { label: '概念阶段', value: '概念阶段' },
      // { label: '原理图、PCB设计阶段', value: '原理图、PCB设计阶段' },
      // { label: '开发阶段', value: '开发阶段' },
      // { label: '测试阶段', value: '测试阶段' },
      // { label: '产测阶段', value: '产测阶段' },
      // { label: '批量生产阶段', value: '批量生产阶段' },
      // { label: '运维阶段', value: '运维阶段' },
    ],

    rules: [{ required: true, message: '请选择项目进度' }],
    itemType: 'select',
  },{
    name: 'productVersion',
    label: '开发板型号及版本号',
    type: 'text',
    required: true,
    placeholder:'请填写系统版本号或芯片型号，如KaihongOS 4.1.3/RK3588',
    rules: [{ required: true, message: '请填写系统版本号或芯片型号，如KaihongOS 4.1.3/RK3588' },{max: 50, message: "最大输入50个字符"}],
    itemType: 'input',
  },{
    name: 'proposeTime',
    label: '提出时间',
    type: 'text',
    disabled:true,
    required: true,
    itemType: 'input',
  },{
    name: 'priority',
    label: '优先级',
    options:[
      { label: '高', value: '高' },
      { label: '中', value: '中' },
      { label: '低', value: '低' },
    ],
    rules: [{ required: true, message: '请选择优先级' }],
    placeholder: '请选择优先级',
    required: true,
    itemType: 'select',
  },{
    name: 'contact',
    label: '联系方式',
    type: 'text',
    placeholder:'请输入联系方式',
    required: true,
    rules: [{ required: true, message: '请输入联系方式' },{max: 50, message: "最大输入50个字符"}],
    itemType: 'input',
  }]